import { render, staticRenderFns } from "./AddInvitation.vue?vue&type=template&id=4fd287d3&scoped=true&"
import script from "./AddInvitation.vue?vue&type=script&lang=js&"
export * from "./AddInvitation.vue?vue&type=script&lang=js&"
import style0 from "./AddInvitation.vue?vue&type=style&index=0&id=4fd287d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd287d3",
  null
  
)

export default component.exports